module.exports = __webpack_public_path__ + "static/media/expired.56320abd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/expired.png
// module id = 1117
// module chunks = 21